module.exports = __webpack_public_path__ + "media/images/lp/lp17-5b4a45fd9c3fa8404b1faac97b5a742a.webp";